<template lang="pug">
.custom-icon(:class="size")
  .image(:style="{ backgroundImage: `url(${resolve(item)})` }")

</template>

<script>

export default {
  props: {
    item: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'sm'
    }
  },

  methods: {
    resolve (item) {
      let filename = ''

      switch (item) {
        case 'energy':
          filename = 'energy_256.png'
          break
        case 'battery':
          filename = 'battery_256.png'
          break
        case 'iron-ore':
          filename = 'iron-ore_256.png'
          break
        case 'iron':
          filename = 'iron-ingot_256.png'
          break
        case 'copper-ore':
          filename = 'copper-ore_256.png'
          break
        case 'copper':
          filename = 'copper-ingot_256.png'
          break
        case 'gold-ore':
          filename = 'caterium-ore_256.png'
          break
        case 'gold':
          filename = 'caterium-ingot_256.png'
          break
        case 'quartz-ore':
          filename = 'raw-quartz_256.png'
          break
        case 'quartz':
          filename = 'quartz-crystal_256.png'
          break
        case 'coal':
          filename = 'coal_256.png'
          break
        case 'concrete':
          filename = 'concrete_256.png'
          break
        case 'uranium':
          filename = 'uranium_256.png'
          break
        case 'stone':
          filename = 'limestone_256.png'
          break
        case 'plastic':
          filename = 'plastic_256.png'
          break
        case 'water':
          filename = 'packaged-water_256.png'
          break
        default:
          filename = `${item}_256.png`
          break
      }

      if (!filename) {
        filename = 'question-mark.png'
      }

      let file = null
      try {
        file = require(`@/assets/images/${filename}`)
      } catch (e) {
        file = require(`@/assets/images/question-mark.png`)
      }

      return file
    }
  }
}

</script>

<style lang="scss" scoped>

.custom-icon {
  &.xs {
    width: 16px;
    height: 16px;
  }

  &.sm {
    width: 32px;
    height: 32px;
  }

  &.md {
    width: 64px;
    height: 64px;
  }

  &.lg {
    width: 128px;
    height: 128px;
  }

  &.xl {
    width: 256px;
    height: 256px;
  }

  .image {
    height: 100%;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Icon.vue